module.exports = __webpack_public_path__ + "img/swt.0a556904.png";